import axios from 'axios';

const { additionalHeaders, loginRootUrl } = window.appAirDrop.config;

export interface MFAOtpType {
  mfaSigninOtpType: string
}

export async function sendVerificationCodeByEscrow(escrowId: string, data: MFAOtpType) {
  const path = `${loginRootUrl}/login/sendVerificationCode/${escrowId}`;
  const response = await axios.post(
    path,
    data,
    {
      headers: {
        ...(additionalHeaders ?? {}),
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      withCredentials: true,
    },
  );

  return response;
}
